<div *ngIf="isLoggedInData" class="flyout-feed-container flyout-loggedin-feed">
  <div class="feed-notifications">
    <h5 *ngIf="feedNotification.length > 0" class="feed-titles">
      <div class="flyout-spacing">Notifications</div>
    </h5>
    <div class="flyout-spacing">
      <ul class="pl-0 mb-0">
        <li *ngFor="let notify of feedNotification" class="advisory-list">
          <a
            [attr.href]="notify.messageURL ? notify.messageURL : '#'"
            [attr.target]="
              contentNotification &&
              contentNotification.notificationViewNewTab === 'true'
                ? '_blank'
                : ''
            "
            class="advisory-container pb-4"
          >
            <h5 class="notify-header text-left">
              {{ notify?.messageHeader }}
            </h5>
            <span *ngIf="notify?.messageBody" class="notify-desc text-left">
              {{ notify?.messageBody }}
            </span>
            <span class="notify-timestamp text-left">
              {{ notify?.flightDate | date : 'MMM dd' }}, DL{{
                notify?.flightNumber
              }}: {{ notify?.flightOrigin }}
              <span class="dark-triangle d-inline-block"></span>
              <span class="sr-only">to</span>
              {{ notify?.flightDestination }}
            </span>
          </a>
        </li>
      </ul>
      <div
        *ngIf="showEmptyMessage"
        class="empty-result text-center"
        role="alert"
      >
        <span>There are no notifications updates at this time.</span>
      </div>
    </div>
    <div *ngIf="feedNotification.length > 0" class="flyout-spacing">
      <a
        [attr.href]="
          contentNotification
            ? contentNotification.notificationViewAllLink
            : '#'
        "
        class="view-all-link"
        target="_blank"
      >
        <span aria-hidden="true">
          {{
            contentNotification
              ? contentNotification.notificationViewAllLabel
              : 'View All'
          }}
        </span>
        <span class="sr-only">
          view all notification Link opens in a new tab
        </span>
      </a>
    </div>
  </div>

  <div class="feed-advisories">
    <h5 class="feed-titles">
      <div class="flyout-spacing">Advisories</div>
    </h5>
    <div *ngIf="advisories.length > 0" class="flyout-spacing">
      <ul *ngIf="advisories" class="pl-0 mb-0">
        <li *ngFor="let advisory of advisories" class="advisory-list">
          <a
            [attr.href]="advisory.pageurl ? advisory.pageurl : '#'"
            [attr.target]="
              contentNotification &&
              contentNotification.advisoriesViewNewWindow === 'true'
                ? '_blank'
                : ''
            "
            class="advisory-container pb-4"
          >
            <h5 class="advisory-header text-left">
              {{ advisory.title }}
            </h5>
            <span *ngIf="advisory.Description" class="advisory-desc text-left">
              {{ advisory.Description }}
            </span>
            <span class="advisory-timestamp text-left">
              {{ advisory.timestamp }}
            </span>
          </a>
        </li>
      </ul>

      <div
        *ngIf="showEmptyMessage"
        class="empty-result text-center"
        role="alert"
      >
        <span>There are no advisories at this time.</span>
      </div>
    </div>
    <div class="flyout-spacing">
      <a
        [attr.href]="
          contentNotification ? contentNotification.advisioriesViewAllLink : '#'
        "
        class="view-all-link"
        target="_blank"
      >
        <span aria-hidden="true">
          {{
            contentNotification
              ? contentNotification.advisoriesViewAllLabel
              : 'View All'
          }}
        </span>
        <span class="sr-only">view all advisories Link opens in a new tab</span>
      </a>
    </div>
  </div>
  <div class="feed-news">
    <h5 class="feed-titles">
      <div class="flyout-spacing">News</div>
    </h5>
    <div class="flyout-spacing">
      <ul *ngIf="news" class="pl-0 mb-0">
        <li
          *ngFor="let item of news; last as isLast"
          [ngClass]="{ newsLastEle: isLast }"
          class="advisory-list news-list"
        >
          <a
            [attr.href]="item.link ? item.link : '#'"
            [attr.target]="
              contentNotification &&
              contentNotification.newsViewNewWindow === 'true'
                ? '_blank'
                : ''
            "
            class="advisory-container pb-4"
          >
            <h5
              [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.title)"
              class="advisory-header"
            ></h5>

            <div class="advisory-timestamp news-timestamp">
              {{ item.publishedtime }}
            </div>

            <span class="sr-only">Link opens in a new tab</span>
          </a>
        </li>
      </ul>
      <div
        *ngIf="showEmptyMessageNews"
        class="empty-result text-center"
        role="alert"
      >
        <span>There are no news updates at this time.</span>
      </div>
    </div>
    <div class="flyout-spacing">
      <a
        [attr.href]="
          contentNotification ? contentNotification.newsViewAllLink : '#'
        "
        class="view-all-link"
        target="_blank"
      >
        <span aria-hidden="true">
          {{
            contentNotification
              ? contentNotification.newsViewAllLabel
              : 'View All'
          }}
        </span>
        <span class="sr-only">view all news Link opens in a new tab</span>
      </a>
    </div>
  </div>
</div>
<div *ngIf="!isLoggedInData" class="flyout content-non-loggedin">
  <div
    [style.top.px]="flyOutPositionHeight"
    class="feed-flyout flyout-main-container mt-lg-0 border-top-0 pl-0 pr-0"
  >
    <div class="container container-wrapper">
      <div
        #dialog
        [style.top.px]="flyOutPositionHeight"
        class="flyout-content content content-loggedIn"
        tabindex="0"
      >
        <div class="feed-modal">
          <div class="hp-notification-container">
            <div
              [style.top.px]="flyoutFeedHeaderPosition"
              class="d-md-none d-md-none feed-header bg-dark fixed-top notification-feed-header"
            >
              <div class="text-right">
                <a
                  (click)="close()"
                  class="bg-dark"
                  href="javascript:void(0);"
                  role="button"
                >
                  Close
                </a>
              </div>
            </div>
            <div class="modal-content border-top-0">
              <h4 class="title custom-feed-text" for="Feed" id="feed">
                {{
                  contentNotification ? contentNotification.feedLabel : 'Feed'
                }}
              </h4>
              <div class="modal-body pl-0 pr-0">
                <tabset
                  [ngClass]="{ 'notify-available': isloggedInFeedNotify }"
                  role="tablist"
                >
                  <tab
                    (select)="tabSelected('notifications', $event)"
                    (selectTab)="tabSelected('notifications', $event)"
                    *ngIf="isloggedInFeedNotify && feedNotification"
                    [heading]="
                      contentNotification
                        ? contentNotification.notificationLabel
                        : 'NOTIFICATIONS'
                    "
                    active="true"
                    customClass="notify-tab-link"
                  >
                    <ul *ngIf="feedNotification" class="pl-0 mb-0">
                      <li
                        *ngFor="let notify of feedNotification"
                        class="advisory-list"
                      >
                        <a
                          [attr.href]="
                            notify.messageURL ? notify.messageURL : '#'
                          "
                          [attr.target]="
                            contentNotification &&
                            contentNotification.notificationViewNewTab ===
                              'true'
                              ? '_blank'
                              : ''
                          "
                          class="advisory-container pb-4"
                        >
                          <h5 class="notify-header text-left">
                            {{ notify?.messageHeader }}
                          </h5>
                          <span
                            *ngIf="notify?.messageBody"
                            class="notify-desc text-left"
                          >
                            {{ notify?.messageBody }}
                          </span>
                          <span class="notify-timestamp text-left">
                            {{ notify?.flightDate | date : 'MMM dd' }}, DL{{
                              notify?.flightNumber
                            }}:
                            {{ notify?.flightOrigin }}
                            <span class="dark-triangle d-inline-block"></span>
                            <span class="sr-only">to</span>
                            {{ notify?.flightDestination }}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </tab>
                  <tab
                    (select)="tabSelected('advisories', $event)"
                    (selectTab)="tabSelected('advisories', $event)"
                    *ngIf="isAlwaysShow"
                    [heading]="
                      contentNotification
                        ? contentNotification.advisioriesLabel
                        : 'ADVISORIES1'
                    "
                    active="true"
                    customClass="advisory-tab-link"
                    id="advisory-tab"
                    role="tab"
                  >
                    <ul
                      *ngIf="advisories"
                      aria-labelledby="advisory-tab"
                      class="pl-0 mb-0"
                      role="tabpanel"
                    >
                      <li
                        *ngFor="let advisory of advisories; last as isLast"
                        [ngClass]="{ advisoryLastEle: isLast }"
                        class="advisory-list"
                      >
                        <a
                          [attr.href]="
                            advisory.pageurl ? advisory.pageurl : '#'
                          "
                          [attr.target]="
                            contentNotification &&
                            contentNotification.advisoriesViewNewWindow ===
                              'true'
                              ? '_blank'
                              : ''
                          "
                          class="advisory-container pb-4"
                        >
                          <h5 class="advisory-header text-left">
                            {{ advisory.title }}
                          </h5>
                          <span
                            *ngIf="advisory.Description"
                            class="advisory-desc text-left"
                          >
                            {{ advisory.Description }}
                          </span>
                          <span class="advisory-timestamp text-left">
                            {{ advisory.timestamp }}
                          </span>
                        </a>
                      </li>
                    </ul>
                    <!--<ng-template #notAvailable>Advisories is not avilable </ng-template>-->
                    <div
                      *ngIf="showEmptyMessage"
                      class="empty-result text-center"
                      role="alert"
                    >
                      <span>There are no advisories at this time.</span>
                    </div>
                  </tab>
                  <tab
                    (select)="tabSelected('news', $event)"
                    (selectTab)="tabSelected('news', $event)"
                    *ngIf="isAlwaysShow"
                    [heading]="
                      contentNotification
                        ? contentNotification.newsLabel
                        : 'NEWS1'
                    "
                    customClass="news-tab-link"
                    id="news-tab-link"
                    role="tab"
                  >
                    <ul
                      *ngIf="news"
                      aria-labelledby="news-tab"
                      class="pl-0 mb-0"
                      role="tabpanel"
                    >
                      <li
                        *ngFor="let item of news; last as isLast"
                        [ngClass]="{ newsLastEle: isLast }"
                        class="advisory-list news-list"
                      >
                        <a
                          [attr.href]="item.link ? item.link : '#'"
                          [attr.target]="
                            contentNotification &&
                            contentNotification.newsViewNewWindow === 'true'
                              ? '_blank'
                              : ''
                          "
                          class="advisory-container pb-4"
                        >
                          <h5
                            [innerHTML]="
                              sanitizer.bypassSecurityTrustHtml(item.title)
                            "
                            class="advisory-header"
                          ></h5>

                          <div class="advisory-timestamp news-timestamp">
                            {{ item.publishedtime }}
                          </div>

                          <span class="sr-only">Link opens in a new tab</span>
                        </a>
                      </li>
                    </ul>
                    <div
                      *ngIf="showEmptyMessageNews"
                      class="empty-result text-center"
                      role="alert"
                    >
                      <span>There are no news updates at this time.</span>
                    </div>
                  </tab>
                </tabset>
                <div
                  class="modal-footer mobile-view-all justify-content-start border-0 mobile-view-all-absolute"
                >
                  <a
                    *ngIf="isnotification"
                    [attr.href]="
                      contentNotification
                        ? contentNotification.notificationViewAllLink
                        : '#'
                    "
                    class="advisories-view-all-link"
                    target="_blank"
                  >
                    <span aria-hidden="true">
                      {{
                        contentNotification
                          ? contentNotification.notificationViewAllLabel
                          : 'View All'
                      }}
                    </span>
                    <span class="sr-only">
                      view all notification Link opens in a new tab
                    </span>
                  </a>
                  <a
                    *ngIf="isadvisories"
                    [attr.href]="
                      contentNotification
                        ? contentNotification.advisioriesViewAllLink
                        : '#'
                    "
                    class="advisories-view-all-link"
                    target="_blank"
                  >
                    <span aria-hidden="true">
                      {{
                        contentNotification
                          ? contentNotification.advisoriesViewAllLabel
                          : 'View All'
                      }}
                    </span>
                    <span class="sr-only">
                      view all advisories Link opens in a new tab
                    </span>
                  </a>
                  <a
                    *ngIf="isnews"
                    [attr.href]="
                      contentNotification
                        ? contentNotification.newsViewAllLink
                        : '#'
                    "
                    class="news-view-all-link"
                    target="_blank"
                  >
                    <span aria-hidden="true">
                      {{
                        contentNotification
                          ? contentNotification.newsViewAllLabel
                          : 'View All'
                      }}
                    </span>
                    <span class="sr-only">
                      view all news Link opens in a new tab
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="spinner" class="spinner-overlay">
          <div class="spinner-loading">
            <div class="loader-holder"></div>
            <h2>Loading...</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
